"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const error_module_css_1 = __importDefault(require("./error.module.css"));
const react_intl_1 = require("react-intl");
const web_sds_c_1 = require("@snapchat/web-sds-c");
/**
 *
 */
function ErrorScreen({ onClick }) {
    const onButtonClick = () => {
        onClick?.();
        // TODO: replace it with getWindow()
        window.location.reload();
    };
    // https://static.snapchat.com/images/coffee-spill.svg
    // https://static.snapchat.com/images/spill-coffee.svg
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: error_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)("img", { src: "https://static.snapchat.com/images/coffee-spill.svg", width: 200, height: 200 }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "udmFsG", defaultMessage: "An error occurred. Please reload the page.", description: "error message" }), (0, jsx_runtime_1.jsx)(web_sds_c_1.ButtonOrLink, { dataTest: "reload", className: error_module_css_1.default.btn, onClick: onButtonClick, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "A+17s3", defaultMessage: "Reload page", description: "reload button text" }) })] }) }));
}
exports.default = ErrorScreen;
//# sourceMappingURL=index.js.map